import { createReducer } from "@reduxjs/toolkit";
 const initialState = {
   activeMenuTab:"shirtSettings",
      selectedPrintType:"trending",
      activeImageList:[
        'https://i.ibb.co/xFHLs71/Asset-1.png',
'https://i.ibb.co/3Syr68K/Asset-2.png',
'https://i.ibb.co/McxkkXq/Asset-3.png',
'https://i.ibb.co/y6CCmJ6/Asset-4.png',
'https://i.ibb.co/MG8Hsmf/Asset-5.png',
'https://i.ibb.co/cwM7YwX/Asset-6.png',
'https://i.ibb.co/P4QQ20z/Asset-7.png',
'https://i.ibb.co/B4BBbd0/Asset-8.png',
'https://i.ibb.co/9nFpX01/Asset-9.png',
'https://i.ibb.co/WtvbcZR/Asset-10.png',
'https://i.ibb.co/VjxkbXS/Asset-11.png',
'https://i.ibb.co/hZ8hszf/Asset-12.png',
'https://i.ibb.co/1qVKSfv/Asset-42.png',
'https://i.ibb.co/nn1TWxh/Untitled-2.png',
'https://i.ibb.co/1q8ypRD/Untitled-3.png',
'https://i.ibb.co/WcW9j7H/Untitled-4.png'

,],


      printTypeImages:[{type:"Arabic",images:[
        'https://i.ibb.co/xFHLs71/Asset-1.png',
        'https://i.ibb.co/3Syr68K/Asset-2.png',
        'https://i.ibb.co/McxkkXq/Asset-3.png',
        'https://i.ibb.co/y6CCmJ6/Asset-4.png',
        'https://i.ibb.co/MG8Hsmf/Asset-5.png',
        'https://i.ibb.co/cwM7YwX/Asset-6.png',
        'https://i.ibb.co/P4QQ20z/Asset-7.png',
        'https://i.ibb.co/B4BBbd0/Asset-8.png',
        'https://i.ibb.co/9nFpX01/Asset-9.png',
        'https://i.ibb.co/WtvbcZR/Asset-10.png',
        'https://i.ibb.co/VjxkbXS/Asset-11.png',
        'https://i.ibb.co/hZ8hszf/Asset-12.png',
        'https://i.ibb.co/1qVKSfv/Asset-42.png',
        'https://i.ibb.co/nn1TWxh/Untitled-2.png',
        'https://i.ibb.co/1q8ypRD/Untitled-3.png',
        'https://i.ibb.co/WcW9j7H/Untitled-4.png'
    ]}
      ,{type:"cool designs",images:[
        'https://i.ibb.co/bdRtqhk/Asset-1.png',
'https://i.ibb.co/TvtqGJs/Asset-2.png',
'https://i.ibb.co/0nwcs4Z/Asset-3.png',
'https://i.ibb.co/R4TdCwX/Asset-4.png',
'https://i.ibb.co/xjzz7jB/Asset-10.png',
'https://i.ibb.co/xfrRQjY/Asset-14.png',
'https://i.ibb.co/7VKx5KD/Asset-15.png',
'https://i.ibb.co/BBC6G9D/Asset-19.png',
'https://i.ibb.co/bvkS4sh/Asset-20.png',
'https://i.ibb.co/PGHcRtL/Asset-23.png',
'https://i.ibb.co/8sT70zZ/Asset-24.png',
'https://i.ibb.co/MsbdHvz/Asset-28.png',
'https://i.ibb.co/XyMcwKN/Asset-29.png',
'https://i.ibb.co/fxjS1s2/Asset-30.png',
'https://i.ibb.co/55MX6Db/Asset-31.png',
'https://i.ibb.co/Mfdyyzm/astro.png',
'https://i.ibb.co/JRY01P6/Asset-33.png',
'https://i.ibb.co/QXkVCM0/Asset-37.png',
'https://i.ibb.co/JzjB2H7/Asset-39.png'
      ]}
      ,{type:"gym",images:[
'https://i.ibb.co/YcN63zj/Asset-15.png',
'https://i.ibb.co/WHrGk1F/Asset-13.png',
'https://i.ibb.co/5kHY1jh/Asset-6.png',
'https://i.ibb.co/W3WQzVH/Asset-5.png',
'https://i.ibb.co/fkjkWnC/Asset-4.png',
'https://i.ibb.co/Sdk70DM/Asset-1.png',
'https://i.ibb.co/cgWHWdk/Asset-3.png',

      ]}],
      loader:false,
      drawingCanvas:"",
      selectedShirtColor:"#FFFFFF",
      showFrontView:true,
      frontCanvasJson:"",
      backCanvasJson:"",
      availableShirtTypes:[{name:"Hoodie",value:"Hoodie",frontImageUrl:"/Assets/img/mens_hoodie_front.png",backImageUrl:"/Assets/img/mens_hoodie_back.png",price:0,availableColors:['#ffffff','#000000','#808080','#8B0000','#054907','#0000ff','#FFFF00','#152238'],availableSizes:[{value:'Large',descibtion:"100% Cotton hoodie ,Weight:85-97 kg, Height:185cm-195cm",price:200,colors:['#000000','#000035']},{value:'XLarge',descibtion:"100% Cotton Hoodie, Weight:94-110 kg, Height:190cm-205cm",price:200,colors:['#000000','#000035']},{value:'XXLarge',descibtion:"100% Cotton Hoodie, Weight:100-110 kg, Height:180+cm",price:200,colors:['#000000','#000035']},{value:'XXXLarge',descibtion:"Milton Hoodie, Weight:110-120 kg, Height:175cm-190cm",price:150,colors:['#ffffff','#000000','#808080','#8B0000','#054907']},{value:'XXXXLarge',descibtion:"Milton Hoodie, Weight:120-130 kg, Height:180+cm",price:150,colors:['#ffffff','#000000','#808080','#8B0000','#054907']},{value:'XXXXXLarge',descibtion:"Milton Hoodie Weight:130-150 kg, Height:180+cm",price:150,colors:['#ffffff','#000000','#808080','#8B0000','#054907']}]},{name:"Long Sleeves Shirt",value:"Long Sleeves Shirt",frontImageUrl:"/Assets/img/longsleeve_front.png",backImageUrl:"/Assets/img/longsleeve_back.png",price:0,availableColors:['#8B0000','#87ceeb'],availableSizes:[{value:'Small',descibtion:"100% Cotton long sleeves ,Weight:55-63 kg, Height:150cm-165cm",price:130,colors:['#8B0000','#87ceeb']},{value:'Medium',descibtion:"100% Cotton Long Sleeve, Weight:63-70 kg, Height:165cm-175cm",price:130,colors:['#8B0000','#87ceeb']},{value:'Large',descibtion:"100% Cotton Long Sleeve, Weight:70-80 kg, Height:170cm-180cm",price:130,colors:['#8B0000','#87ceeb']},{value:'XLarge',descibtion:"100% Cotton Long Sleeve, Weight:80-90 kg, Height:170cm-180cm",price:130,colors:['#8B0000','#87ceeb']},]}],   
      availableColors:[],   
      selectedShirtType:{name:"Hoodie",value:"Hoodie",frontImageUrl:"/Assets/img/mens_hoodie_front.png",backImageUrl:"/Assets/img/mens_hoodie_back.png",price:0,availableColors:['#ffffff','#000000','#808080','#8B0000','#054907','#0000ff','#FFFF00','#152238'],availableSizes:[{value:'Large',descibtion:"100% Cotton hoodie ,Weight:70-80 kg, Height:150cm-170cm",price:200,colors:['#000000','#000035']},{value:'XLarge',descibtion:"100% Cotton Hoodie, Weight:80-90 kg, Height:160cm-180cm",price:200,colors:['#000000','#000035']},{value:'XXLarge',descibtion:"100% Cotton Hoodie, Weight:90-100 kg, Height:160cm-190cm",price:200,colors:['#000000','#000035']},{value:'XXXLarge',descibtion:"Milton Hoodie, Weight:100-110 kg, Height:160cm-190cm",price:150,colors:['#ffffff','#000000','#808080','#8B0000','#054907']},{value:'XXXXLarge',descibtion:"Milton Hoodie, Weight:110-130 kg, Height:160cm-200cm",price:150,colors:['#ffffff','#000000','#808080','#8B0000','#054907']},{value:'XXXXXLarge',descibtion:"Milton Hoodie Weight:130-150, Height:180+cm",price:150,colors:['#ffffff','#000000','#808080','#8B0000','#054907']}]},
      englishFonts:['Corinthia','Bakbak One','Roboto Condensed','Roboto Mono','Shalimar','Fuzzy Bubbles','Bebas Neue','Source Code Pro','Smooch','Lobster','Dancing Script','Meow Script','Pacifico','Shadows Into Light','Abril Fatface','Caveat','Engagement'],
      arabicFonts:[ 'Cairo','Tajawal','Readex Pro','Amiri','Almarai','Changa','Mada','Lalezar','El Messiri','Markazi Text','Harmattan','Lateef','Mirza','Reem Kufi','Lemonada','Katibeh','Rakkas','Aref Ruqaa','Kufam','Scheherazade New','Vibes','Qahiri','Jomhuria'],
      arabicFontFamillies:['fantezy','diwanltr','diwani-bent','thuluth-decorated','reem-kufi','Cairo','Tajawal','Readex Pro','Amiri','Almarai','Changa','Mada','Lalezar','El Messiri','Markazi Text','Harmattan','Lateef','Mirza','Reem Kufi','Lemonada','Katibeh','Rakkas','Aref Ruqaa','Kufam','Scheherazade New','Vibes','Qahiri','Jomhuria'],
      price:200,
      printCount:0,
      size:"",
    //  activateShirtSettings:true,
 }

const designerReducer= createReducer(initialState, (builder) => {
    builder
      .addCase('MENU_KEY_CHANGED', (state, {payload}) => {
      state.activeMenuTab=payload;
      //const requiredShirtDetails=state.availableShirtTypes.filter((shirt)=>shirt.value===payload)[0];
      //state.selectedShirtType=requiredShirtDetails;
      return state;
      }).addCase('SET_CANVAS', (state, {payload}) => {
           state.drawingCanvas=payload;
           //state.canvas=!state.showFrontView;
           return state;
       })
       .addCase('SELECTED_COLOR_CHANGED', (state, {payload}) => {
          state.selectedShirtColor=payload;
          return state;
       }).addCase('SELECTED_SHIRT_TYPE_CHANGED', (state, {payload}) => {
        const requiredShirtDetails=state.availableShirtTypes.filter((shirt)=>shirt.value===payload.type)[0];
        console.error(payload);
        state.price=payload.price;
        state.selectedShirtType=requiredShirtDetails;
        state.availableColors=[];
        return state;
      }).addCase('FLIP_IMAGE_CLICKED', (state, {payload}) => {
           state.showFrontView=!state.showFrontView;
           return state;
         }).addCase('SELECTED_IMAGE_TYPE_CHANGED', (state, {payload}) => {
          state.activeImageList=[];
          var result=state.printTypeImages.filter(print=>print.type===payload);
          state.activeImageList=[...JSON.parse(JSON.stringify(result[0].images))];
          return state;
        }).addCase('SET_FRONT_CANVAS_JSON', (state, {payload}) => {
          state.frontCanvasJson=payload;
          return state;
        }).addCase('SET_BACK_CANVAS_JSON', (state, {payload}) => {
          state.backCanvasJson=payload;
          return state;
        }).addCase('INCREASE_PRICE', (state, {payload}) => {
          if(state.printCount===0){
            state.price+=50;
          }
          else if(state.printCount===1){
            state.price+=0;
          }
          else{
            state.price+=0;
          }
          state.printCount=state.printCount+1;
          
          return state;
        }).addCase('DECREASE_PRICE', (state, {payload}) => {
          if(state.printCount===1){
            state.price-=50;
          }
          else if(state.printCount===2){
            state.price-=0;
          }
          else{
            state.price-=0;
          }
          state.printCount=state.printCount-1;
          return state;
        }).addCase('CHANGE_LOADING_STATE', (state, {payload}) => {
          state.loader=!state.loader;
          return state;

        }).addCase('SET_AVAILABLE_COLORS', (state, {payload}) => {
          state.availableColors=[...payload];
          state.selectedShirtColor=state.availableColors[0];
          return state;
        }).addCase('SET_PRICE', (state, {payload}) => {
          state.price=payload;
          return state;

        }).addCase('SET_SIZE', (state, {payload}) => {
          state.size=payload;
          return state;

        })
         
         
      // .addCase('SELECTED_TAB_CHANGED', (state, {payload}) => {
      //     state.activateShirtSettings=payload;
      //   return state;
      // }).addCase('FLIP_IMAGE_CLICKED', (state, {payload}) => {
      //   state.showFrontView=!state.showFrontView;
      //   return state;
      // }).addCase('SET_CANVAS', (state, {payload}) => {
      //   state.drawingCanvas=payload;
      //   //state.canvas=!state.showFrontView;
      //   return state;
      // }).addDefaultCase((state, action) => {
      //   //state.otherActions++
      //   //console.log("hhh");
      //   return state;
      // })
  })



  export default designerReducer;

